
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface RegistrationLayoutProps {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const RegistrationLayout = ({ title, subtitle, icon, children }: RegistrationLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white p-6">
      <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white mb-12 transition-colors">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Home
      </Link>

      <div className="max-w-md mx-auto space-y-8">
        <div className="text-center space-y-4">
          {icon && (
            <div className="bg-purple-600/20 w-14 h-14 rounded-full mx-auto flex items-center justify-center backdrop-blur-xl border border-purple-500/20">
              {icon}
            </div>
          )}
          <h1 className="text-3xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
            {title}
          </h1>
          <p className="text-gray-400 text-lg">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
};
